<template>
  <div class="playing">
    <span class="playing__bar playing__bar1"></span>
    <span class="playing__bar playing__bar2"></span>
    <span class="playing__bar playing__bar3"></span>
  </div>
</template>

<style scoped>
.playing {
  /* background: rgba(255,255,255,.1); */
  width: 100%;
  height: 100%;
  aspect-ratio: 1/1;
  border-radius: .5rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 20%;
  box-sizing: border-box;
  min-width: 1rem;
  min-height: 1rem;
  max-width: 100vw;
  max-height: 100vw;
}

.playing__bar {
  display: inline-block;
  background: white;
  width: 30%;
  height: 100%;
  animation: up-and-down 1.3s ease infinite alternate;
  border-radius: 0.25rem;
}

.playing__bar1 {
  height: 60%;
}

.playing__bar2 {
  height: 30%;
  animation-delay: -2.2s;
}

.playing__bar3 {
  height: 75%;
  animation-delay: -3.7s;
}

@keyframes up-and-down {
  10% {
    height: 30%;
  }
  30% {
    height: 100%;
  }
  60% {
    height: 50%;
  }
  80% {
    height: 75%;
  }
  100% {
    height: 60%;
  }
}
</style>